export default "__VITE_ASSET__uqlOs5La__"